var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeMedicamentos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0508 14V10H5.05078V14C2.85078 14 1.05078 15.8 1.05078 18V45C1.05078 47.2 2.85078 49 5.05078 49H27.0508C29.2508 49 31.0508 47.2 31.0508 45V18C31.0508 15.8 29.2508 14 27.0508 14Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0508 1H3.05078V10H29.0508V1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.1V9.95002L31.1 9.90002V10.1H1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0508 22.5H1.05078V40.5H31.0508V22.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0508 31.45H16.1008V27.5H16.0008V31.45H12.0508V31.55H16.0008V35.5H16.1008V31.55H20.0508V31.45Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0508 43.46C19.0508 40.41 21.5408 37.92 24.5908 37.92H31.0508V18C31.0508 15.8 29.2508 14 27.0508 14V10.05H31.0508V9.95H29.0508V1H3.05078V9.95H1.05078V10.05H5.05078V14C2.85078 14 1.05078 15.8 1.05078 18V45C1.05078 47.2 2.85078 49 5.05078 49H24.5908C21.5408 49 19.0508 46.51 19.0508 43.46Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5908 37.92C21.5408 37.92 19.0508 40.41 19.0508 43.46C19.0508 46.51 21.5408 49 24.5908 49H31.0508V37.92H24.5908Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5108 37.92H31.0508V49H37.5108C40.5608 49 43.0508 46.51 43.0508 43.46C43.0508 40.41 40.5608 37.92 37.5108 37.92Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1017 43.46H39.0017C39.0017 42.65 38.3217 41.97 37.5117 41.97V41.87C38.3717 41.87 39.1017 42.6 39.1017 43.46Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.05,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMedicamentos);
export default __webpack_public_path__ + "static/media/icone-medicamentos.0bbe8451ca7e8375967303270c672ccf.svg";
export { ForwardRef as ReactComponent };